(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      var searchContainer = this.header.querySelector('[data-header-search]');
      if (searchContainer) {
        searchContainer.classList.remove('is-expanded');
        var input = searchContainer.querySelector('.header__search-bar-input');
        if (input) input.value = '';
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.header__product-slider').forEach(function (slider) {
      const track = slider.querySelector('.header__product-slider-track');
      const prevBtn = slider.querySelector('.header__product-slider-btn--prev');
      const nextBtn = slider.querySelector('.header__product-slider-btn--next');
      const scrollAmount = 280;

      if (prevBtn && track) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });
      }
      if (nextBtn && track) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });
      }
    });

    document.querySelectorAll('.drawer-accordion__toggle').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        const content = btn.nextElementSibling;
        btn.setAttribute('aria-expanded', String(!expanded));
        content.classList.toggle('is-open', !expanded);
      });
    });

    document.querySelectorAll('.drawer-accordion__slider').forEach(function (slider) {
      const track = slider.querySelector('.drawer-accordion__slider-track');
      const scrollbar = slider.querySelector('.drawer-accordion__slider-scrollbar');
      const scrollbarTrack = slider.querySelector('.drawer-accordion__slider-scrollbar-track');
      const thumb = slider.querySelector('.drawer-accordion__slider-scrollbar-thumb');
      if (!track || !scrollbar || !scrollbarTrack || !thumb) return;

      function updateCustomScrollbar() {
        var scrollWidth = track.scrollWidth;
        var clientWidth = track.clientWidth;
        var maxScroll = scrollWidth - clientWidth;
        if (maxScroll <= 0) {
          scrollbar.style.display = 'none';
          return;
        }
        scrollbar.style.display = '';
        var barWidth = scrollbarTrack.clientWidth;
        var thumbWidth = Math.max((clientWidth / scrollWidth) * barWidth, 24);
        var maxThumbLeft = Math.max(0, barWidth - thumbWidth);
        var ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
        thumb.style.width = thumbWidth + 'px';
        thumb.style.left = ratio * maxThumbLeft + 'px';
      }

      track.addEventListener('scroll', updateCustomScrollbar);
      window.addEventListener('resize', updateCustomScrollbar);
      var ro = new ResizeObserver(updateCustomScrollbar);
      ro.observe(track);
      ro.observe(scrollbarTrack);

      track.querySelectorAll('img').forEach(function (img) {
        img.addEventListener('load', updateCustomScrollbar);
      });

      thumb.addEventListener('pointerdown', function (e) {
        if (e.button !== 0) return;
        e.preventDefault();
        var startX = e.clientX;
        var startScrollLeft = track.scrollLeft;
        var maxScroll = track.scrollWidth - track.clientWidth;
        var barWidth = scrollbarTrack.clientWidth;
        var thumbWidth = thumb.offsetWidth;
        var maxThumbLeft = Math.max(0, barWidth - thumbWidth);

        function onMove(ev) {
          var dx = ev.clientX - startX;
          var scrollDelta = maxThumbLeft > 0 ? (dx / maxThumbLeft) * maxScroll : 0;
          track.scrollLeft = Math.max(0, Math.min(maxScroll, startScrollLeft + scrollDelta));
        }
        function onUp() {
          document.removeEventListener('pointermove', onMove);
          document.removeEventListener('pointerup', onUp);
        }
        document.addEventListener('pointermove', onMove);
        document.addEventListener('pointerup', onUp);
      });

      scrollbarTrack.addEventListener('pointerdown', function (e) {
        if (e.target === thumb) return;
        var rect = scrollbarTrack.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var barWidth = scrollbarTrack.clientWidth;
        var scrollWidth = track.scrollWidth;
        var clientWidth = track.clientWidth;
        var thumbWidth = Math.max((clientWidth / scrollWidth) * barWidth, 24);
        var maxScroll = scrollWidth - clientWidth;
        var maxThumbLeft = Math.max(0, barWidth - thumbWidth);
        var targetLeft = Math.max(0, Math.min(maxThumbLeft, x - thumbWidth / 2));
        var ratio = maxThumbLeft > 0 ? targetLeft / maxThumbLeft : 0;
        track.scrollLeft = ratio * maxScroll;
      });

      updateCustomScrollbar();
    });
  });

  document.querySelectorAll('.header__mobile-search-trigger').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var headerDrawer = btn.closest('header-drawer');
      if (!headerDrawer) return;
      var summary = headerDrawer.querySelector('summary');
      if (!summary) return;
      var details = summary.parentElement;
      if (details && !details.open) {
        summary.click();
        setTimeout(function() {
          var searchInput = headerDrawer.querySelector('.menu-drawer__search input[type="search"]');
          if (searchInput) searchInput.focus();
        }, 350);
      }
    });
  });

  document.querySelectorAll('[data-header-search]').forEach(function(searchContainer) {
    var toggleBtn = searchContainer.querySelector('[data-search-toggle]');
    var closeBtn = searchContainer.querySelector('[data-search-close]');
    var searchInput = searchContainer.querySelector('.header__search-bar-input');

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function(e) {
        e.preventDefault();
        searchContainer.classList.add('is-expanded');
        if (searchInput) {
          setTimeout(function() { searchInput.focus(); }, 100);
        }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        searchContainer.classList.remove('is-expanded');
        if (searchInput) searchInput.value = '';
      });
    }

    document.addEventListener('click', function(e) {
      if (!searchContainer.contains(e.target) && searchContainer.classList.contains('is-expanded')) {
        searchContainer.classList.remove('is-expanded');
        if (searchInput) searchInput.value = '';
      }
    });

    if (searchInput) {
      searchInput.addEventListener('keyup', function(e) {
        if (e.key === 'Escape') {
          searchContainer.classList.remove('is-expanded');
          searchInput.value = '';
          if (toggleBtn) toggleBtn.focus();
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
